export const GROUP_COLORS = {
  Supervisor:    "#0E7490",
  Gerente:       "#0E7490",
  Administrador: "#0E7490",
  Empleado:      "#15803D",
};

export default function GroupTag({ name }) {
  const bg = GROUP_COLORS[name] ?? "var(--color-brand-600)";
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        height: 24,
        padding: "0 10px",
        borderRadius: 100,
        background: bg,
        color: "#fff",
        fontSize: 13,
        fontWeight: 500,
        fontFamily: "DM Sans",
        whiteSpace: "nowrap",
      }}
    >
      {name}
    </span>
  );
}
